<template>
	<div class="small-12 flex page propertiesDashboard animated fadeIn" v-if="loaded && user">
		<primary-nav :user="user"/>
		<div class="small-12 large-10 pageContentWrap">
			<div class="small-12 pageContent">
				<div class="small-12 centerColumn flex">
					<properties-nav/>
					<free-to-invest/>
					<properties-listing :total_properties="total_properties" :properties="properties" :user="user" :company="company" @deleteProperty="updateProperties"/>
					<user-footer/>
				</div>
			</div>
		</div>
	</div>
	<loading-spinner :loaded="loaded" v-else/>
</template>

<script>
	
	// Import firebase
	import { firebaseAuth, usersModel, propertiesModel, companiesModel } from '@/firebase/firebase-config'

	// Import the components
	import UserFooter from '@/components/framework/footer/UserFooter.vue'
	import LoadingSpinner from '@/components/framework/helpers/LoadingSpinner.vue'
	import PrimaryNav from '@/components/framework/nav/PrimaryNav.vue'
	import PropertiesNav from '@/components/properties/dashboard/PropertiesNav.vue'
	import PropertiesListing from '@/components/properties/dashboard/PropertiesListing.vue'
	import FreeToInvest from '@/components/properties/shared/FreeToInvest.vue'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

	export default {

		/*
		** Set the component name
		*/

		name: 'Index',

		/*
		**  Register the components
		*/

		components: {

			LoadingSpinner,
			UserFooter,
			PrimaryNav,
			PropertiesNav,
			PropertiesListing,
			FreeToInvest

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService

		],

		/*
		**  Set up the data
		*/

		data: () => ({

			user: null,
			company: null,
			loaded: false,
			properties: [],
			total_properties: 0

		}),

		/*
		**  Do this first
		*/

		created() {

			// Get the user
			this.getUser();

		},

		/*
		**  Set up the methods
		*/

		methods: {

			getUser: function() {

				// Get the user doc
				usersModel.doc(firebaseAuth.currentUser.uid).get()
				.then(doc => {

					if (!doc.exists) return;

					// Set the prop
					this.user = doc.data();

				})
				.then(() => {

					// Get the properties
					if (this.user) this.getProperties();

				})
				.then(() => {

					// Get the company
					if (this.user && this.user.relationships.company) this.getCompany();

				})
				.then(() => {

					// Set the prop
					this.loaded = true;

				})
				.catch(error => {

					// Send to bugsnag
					this.reportAuthBugsnagError({
						title: 'Properties Dashboard Index - Get User Document',
						errorType: 'Firestore Database',
						section: 'Properties',
						component: 'Index',
						error: error
					});

				});

			},

			getProperties: function() {

				// Get the properties
				propertiesModel.where('relationships.user', '==', this.user.id).where('meta.deleted_at', '==', null).get()
				.then(snapshot => {

					if (snapshot.empty) return;

					// Add to the prop
					snapshot.forEach(doc => {

						this.properties.push(doc.data());

						// Set the total count
						this.total_properties++;

					});

				})
				.catch(error => {

					// Send to bugsnag
					this.reportAuthBugsnagError({
						title: 'Properties Dashboard Index - Get Properties',
						errorType: 'Firestore Database',
						section: 'Properties',
						component: 'Index',
						error: error
					});

				});

			},

			updateProperties: function(value) {

				// Update the properties
				if (value) {

					// Reset the properties
					this.properties = [];

					// Set the total count
					this.total_properties = 0;

					// Get the new properties
					this.getProperties();

				}

			},

			getCompany: function() {

				// Get the company
				companiesModel.doc(this.user.relationships.company).get()
				.then(doc => {

					if (!doc.exists) return;

					// Add to the prop
					this.company = doc.data();

				})
				.catch(error => {

					// Send to bugsnag
					this.reportAuthBugsnagError({
						title: 'Properties Index - Get Company Document',
						errorType: 'Firestore Database',
						section: 'Properties',
						component: 'Index',
						error: error
					});

				});

			}

		}

	}

</script>